import React from "react";
import Navbar from "../components/Navbar/NavbarDashboard";

function Page3() {
  return (
    <div>
      <Navbar />
      <h1>Page 4</h1>
    </div>
  );
}
export default Page3;
